module.exports = __webpack_public_path__ + "img/logo_.a6406e7d.png";